module.exports = __webpack_public_path__ + "img/hamburger-white.97ac8e11.svg";